import React, { useState, useEffect, useRef } from "react"
import Box from "@mui/material/Box"
import {
    CFooter
} from "@coreui/react"
import {  ChatBubbleOutline, StorefrontOutlined } from "@mui/icons-material"
import { Button, Typography } from "@mui/material"

export const ProductFooter = () => {

    const onClickStore = () => {
    };

    const onClickChat = () => {
    };

    return (
        <CFooter position="sticky" className="product-footer-div border-bottom-0">
            <Box className="product-footer-inner-div d-flex" sx={{
                backgroundColor: "#ffffff",
                width: "100%",
                paddingLeft: "20px",
                paddingRight: "20px"
            }}>
                <Box className="store-div" onClick={() => {
                    onClickStore();
                }}>
                    <Box>
                        <StorefrontOutlined className="store-icon" />
                    </Box>
                    <Typography

                        variant="paragraph"
                        className="product-store-text"
                    >
                        Store
                    </Typography>
                </Box>

                <Box className="chat-div"onClick={() => {
                    onClickChat();
                }}>
                    <Box>
                        <ChatBubbleOutline className="chat-icon" />
                    </Box>
                    <Typography
                        
                        variant="paragraph"
                        className="product-chat-text"
                    >
                        Chat
                    </Typography>
                </Box>

                <Box sx={{ width: "100%" }}>
                    <Box className="d-flex justify-content-end">
                        <Box>
                            <Button
                                disableElevation
                                variant="contained"
                                onClick={(event) => {

                                }}
                                className="add-to-cart-left-button"
                            >
                                Add To Cart
                            </Button>
                            <Button
                                disableElevation
                                variant="contained"
                                onClick={(event) => {

                                }}
                                className="get-sample-right-button"
                            >
                                Get Sample
                            </Button>
                        </Box>
                    </Box>
                </Box>

            </Box>
        </CFooter>
    )
}

export default ProductFooter
